<template>
    <div class="categoryView">
        <div v-if="code == 'rdw'" class="rdwTopType">
            <div 
                class="rdwTopTypeList"
                :class="hotTopTypeIndex== index ?'rdwTopTypeListCheck':''"
                v-for="(item,index) in hotTopType"
                :key="index"
                @click="hotDataChoose(index)">
                {{ item.name }}
            </div>
        </div>
        <!--展示列表-->
        <div class="showData">
            <div class="dataList" v-for="(item,index) in showDataList" :key="index">
                <div class="dataListTitle">
                    <div class="dataListText">
                        <span>{{ item.name }}</span>
                    </div>
                    <div class="listIsShowChild" @click="dataListClick(item,index)">
                        <img v-if="item.hidden" :src="imgObj.icon_jianjian" alt="">
                        <img v-else :src="imgObj.icon_jiajia" alt="">
                    </div>
                </div>
                <div class="dataListChild" v-if="item.hidden == true">
                    <div 
                        class="childList"
                        :class="index_c==0?'childListCheck':rdyjCheckIds.indexOf(item_c.id)!=-1?'childListCheck':''"
                        v-for="(item_c,index_c) in item.childs" 
                        :key="index_c" 
                        @click="itemChildClick(item_c,index_c)">
                        <p class="childListP">
                            {{ item_c.name }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!--选中 层级-->
        <div class="floatCheck" v-if="ydwHandle.isShow">
            <!--顶部展示  标签名 开始咨询 返回上一级 关闭-->
            <div class="categoryChildTop">
                <div class="categoryTopName">
                    <span :class="ydwHandle.levelNames.length==0?'yellowSpan':''">
                        {{ lastCheck.name }}
                        <span v-if="ydwHandle.levelNames.length!=0">{{ jjh }}</span>
                    </span>
                    <span v-for="(item,index) in ydwHandle.levelNames" :key="index">
                        <span :class="index == ydwHandle.levelNames.length - 1?'yellowSpan':''">{{ item }}</span>
                        <span v-if="index != ydwHandle.levelNames.length - 1">{{ jjh }}</span>
                    </span>
                </div>
                <div class="categoryTopHandle">
                    <div class="topHandleLeft" @click="tagTreeStart">
                        <img src="" alt="">
                        <span>开始咨询</span>
                    </div>
                    <div class="topHandleRight">
                        <div class="tHRightTReturn" @click="returnLevel">返回上一级</div>
                        <div class="tHRightTClose" @click="closeLevel">关闭</div>
                    </div>
                </div>
            </div>
            <!--文字介绍啊-->
            <div class="categoryChildText">
                <p>
                    <span>以下是</span>
                    <span class="buleSpan">“{{ lastCheck.name }}”</span>
                    <span>的引导分类，点击分类可以立刻咨询。同时，根据引导继续点击下一级进行咨询。同时也可以点击“返回上一级”，查看引导路径</span>
                </p>
            </div>
            <!--子级的展示 -->
            <div class="categoryChildBox">
                <div 
                    class="categoryChildList"
                    :class="(index==0&&ydwHandle.parentCheck.length==0)?'categoryChildListCheck':ydwHandle.parentCheck.indexOf(item.id)!=-1?'categoryChildListCheck':''"
                    v-for="(item,index) in ydwHandle.showData" 
                    :key="index"
                    @click="tagTreeClick(item,index)">
                    <p>{{ item.name }}</p>
                </div>
            </div>
        </div> 
    </div>
</template>
<script>

import icon_jiajia from '@/assets/icon/00b-15px_15px.png'
import icon_jianjian from '@/assets/icon/01b-15px_15px.png'


//接口 
import { jczdGetTagTree,getTagTree } from '@/api/api.js'
export default {
    name:'',
    props:['sendDataCode'],
    data(){
        return{
            imgObj:{
                icon_jiajia,
                icon_jianjian
            },
            dataObj:{
                ydw:{
                    rootCategoryId: 5759,
                    categoryType: 'znws_menu_type',
                    collectionCode:'aiw-ydw',
                },
                rdw:{
                    rootCategoryId: 5405,
                    categoryType: "zhzsk_ws_type",
                    collectionCode:'aiw-rdyj',
                },
                fxkz:{
                    rootCategoryId: 19360,
                    categoryType: 'zhzsk_zsg_tag_type',
                    orderField: 'sort',
                    orderType: 'desc',
                }
            },
            jjh:'>',
            code:'',
            //数据的列表
            showDataList:[],
            //热点问的分类
            hotTopType:[],
            hotTopTypeIndex:0,
            //热点预警的分类选择
            rdyjCheckIds:[],
            //引导问展示子级时的
            ydwHandle:{
                isShow:false,
                level:1,
                showData:[],
                levelCheck:{},
                levelNames:[],
                parentCheck:[],
                pId:'',
            },
            getTagTreeAll:[],
            //最底层的那级选中
            lastCheck:{},
            //引导问当前选中的
            ydwNowCheck:{},
            //回显
            thatCheckHistory:{}
        }
    },
    created(){

    },
    mounted(){
        console.log('tag')
        //console.log(this.$props.sendDataCode);
        this.code = this.$props.sendDataCode
        this.getCategoryTreeData();
    },
    methods:{
        //获取分类数据
        getCategoryTreeData(){
            this.loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            })
            let data = this.dataObj[this.code]
            jczdGetTagTree(data).then(res => {
                //console.log(res)
                if(res.status==200&&res.data.status==0){
                    let tRes = res.data.data;
                    //判断code
                    if(this.code == 'ydw'){
                        //多获取一个风险控制
                        let thatData = tRes;
                        this.getFXKZ(thatData);
                    }else{
                        let list0 = JSON.parse(JSON.stringify(tRes[0]));
                        let list1 = JSON.parse(JSON.stringify(tRes[1]));
                        tRes[0] = list1
                        tRes[1] = list0
                        this.hotTopType = tRes;
                        //选中第一个
                        this.hotDataChoose(0)
                        this.loading.close()
                    }
                    
                }
            })
        },
        getFXKZ(thatData){
            let data = this.dataObj['fxkz']
            jczdGetTagTree(data).then(res => {
                if(res.status==200&&res.data.status==0){
                    let rRes = res.data.data
                    //创建新的对象
                    let newObj = {
                        name:"风险控制",
                        childs:rRes,
                        hidden:false,
                        id:'987564'
                    }
                    thatData.push(newObj)
                    //遍历
                    let newArr = this.eachAddKey(thatData)
                    this.showDataList = newArr
                    this.loading.close()
                }
                console.log(res)
            })
        },
        eachAddKey(arr){
            for(let a=0;a<arr.length;a++){
                arr[a].childCheckArr = []
                if(arr[a].childs||arr[a].children){
                    this.eachAddKey(arr[a].childs||arr[a].children)
                }
            }
            return arr
        },
        //遍历数据
        eachArrList(arr,pId,tId){
            for(let a=0;a<arr.length;a++){
                if(arr[a].id == pId){
                    //判断是否包含
                    if(arr[a].childCheckArr.indexOf(tId)!=-1){
                        arr[a].childCheckArr.splice(arr[a].childCheckArr.indexOf(tId), 1);
                    }
                    //debugger
                    arr[a].childCheckArr.push(tId);
                    return
                }
                if(arr[a].childs||arr[a].children){
                    this.eachArrList(arr[a].childs||arr[a].children,pId,tId)
                }
            }
        },
        //热点预警的分类选择
        hotDataChoose(index){
            //选中索引
            this.hotTopTypeIndex = index;

            let thatData = this.hotTopType[index].childs;
            let newArr = this.forFN(thatData);
            //console.log(newArr)
            

            let newArr1 = this.eachAddKey(newArr)
            //展示数据
            this.showDataList = newArr1;
        },
        //收起展开
        dataListClick(item,index){
            item.hidden = !item.hidden
            //console.log(index)
        },
        //子级点击的判断
        itemChildClick(item,index){
            console.log(item,index)
            this.eachArrList(this.showDataList,item.parentId,item.id)

            console.log(this.showDataList)
            //return
            //判断分类 是引导问 还是热点预警 热点预警直接进行sse 
            if(this.code == 'rdw'){
                this.$parent.categoryViewFN(item.name,this.code)
            }else{
                this.lastCheck = item
                this.getTagTreeFN(item)
            }
            //this.thatCheckHistory
            //添加本次的点击记录
            this.rdyjCheckIds.push(item.id)
        },
        //循环
        forFN(arr){
            //console.log(arr)
            //子级的第一个和父级同名就不显示
            for(let a=0;a<arr.length;a++){
                let tObj = arr[a]
                let tName = arr[a].name
                //第一个是否一样
                if(tName == tObj.childs[0].name){
                    tObj.childs.splice(0, 1);
                }
                // for(let b=0;b<tObj.childs.length;b++){
                //     let cName = tObj.childs[b].name
                //     console.log(cName)
                // }
            }
            return arr
        },
        //获取子级的分类
        getTagTreeFN(item){
            this.loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            })
            let data = {
                rootId: item.attribute.extend.tagId,
                level: 4,
            }
            getTagTree(data).then(res => {
                //console.log(res)
                let tRes = res.data.data
                tRes = this.eachAddKey(tRes);
                this.getTagTreeAll = tRes;
                //当前展示的数据 
                this.ydwNowCheck = tRes[0];
                //展示数据赋值
                this.ydwHandle.showData = tRes;
                //层级数据
                this.ydwHandle.levelCheck[this.ydwHandle.level] = tRes;
                //显示数据浮层
                this.ydwHandle.isShow = true;
                this.ydwHandle.pId = item.id;
                // ydwHandle:{
                //     isShow:false,
                //     level:1,
                //     showData:[],
                //     levelCheck:{},
                //     levelNames:[],
                // },

                //console.log(this.ydwNowCheck)
                this.loading.close()
            })
        },
        //展开的树的子级点击 是继续展示子级还是进入SSE
        tagTreeClick(item,index){
            //添加高亮
            // console.log(item)
            
            // console.log(this.getTagTreeAll)
            //debugger
            //判断是最外层
            if(this.ydwHandle.level == 1){
                this.eachArrList(this.showDataList,this.ydwHandle.pId,item.id);
                console.log(this.showDataList)
            }else{
                this.eachArrList(this.getTagTreeAll,item.parentId,item.id);
            }
            //判断子级
            if(item.children&&item.children.length!=0){
                //引导问 当前选中
                this.ydwNowCheck = item.children[0];
                //子级展示
                this.ydwHandle.showData = item.children;
                //添加名字层级
                this.ydwHandle.levelNames.push(item.name);
                //层级 +1 
                this.ydwHandle.level ++;
                //每个层级的选中
                this.ydwHandle.levelCheck[this.ydwHandle.level] = item.children;
                //父层集中选中的子id
                this.ydwHandle.parentCheck = item.childCheckArr
            }else{
                let nameText = this.lastCheck.name + '-' + this.ydwHandle.levelNames.join('-') + item.name;
                //回传给父组件一些参数信息 
                this.$parent.categoryViewFN(nameText,this.code)
            }
            
            
        },
        //返回上一级
        returnLevel(){
            //判断是否是最后一级
            if(this.ydwHandle.level>1){
                //level减少
                this.ydwHandle.level --;
                //展示数据改变
                this.ydwHandle.showData = this.ydwHandle.levelCheck[this.ydwHandle.level];
                //删除展示数据
                delete this.ydwHandle.levelCheck[this.ydwHandle.level + 1]
                //名字层级减少
                this.ydwHandle.levelNames.pop();
                //当前选中的数据
                this.ydwNowCheck = this.ydwHandle.showData;
                //console.log(this.ydwNowCheck)

                //判断是否是最外层
                if(this.ydwHandle.level==1){
                    //console.log(this.ydwHandle.pId)
                    //根据数据找到父级的check
                    this.ydwHandle.parentCheck = this.getCheckParent(this.showDataList,this.ydwHandle.pId,[]);
                    console.log(this.ydwHandle.parentCheck)
                }else{
                    //根据数据找到父级的check
                    this.ydwHandle.parentCheck = this.getCheckParent(this.getTagTreeAll,this.ydwNowCheck[0].parentId,[]);
                }
                //console.log(this.ydwHandle.parentCheck)
            }else{
                //触发关闭
                this.closeLevel()
            }
        },
        //获取check
        getCheckParent(arr,pId,list){
            for(let a=0;a<arr.length;a++){
                // console.log(arr)
                // console.log(a)
                // console.log(arr[a].id)
                // console.log(pId)
                if(arr[a].id == pId){
                    //console.log('找到了')
                    list = arr[a].childCheckArr;
                    return list
                }
                if(arr[a].childs||arr[a].children){
                    list = this.getCheckParent(arr[a].childs||arr[a].children,pId,[])
                    return list
                }
            }
            return list
        },
        //关闭
        closeLevel(){
            //清除展示数据
            this.ydwHandle.isShow = false;
            this.ydwHandle.showData = [];
            this.ydwHandle.level = 1;
            this.ydwHandle.levelCheck = {};
            this.ydwNowCheck = {};
            this.ydwHandle.levelNames = [];
        },
        //开始咨询 选中当前层级的数据
        tagTreeStart(){
            let nameText = this.lastCheck.name + '-' + this.ydwHandle.levelNames.join('-');
            //调用父级页面的方法
            this.$parent.categoryViewFN(nameText,this.code)
        }
    }
}
</script>
<style lang="scss" scoped>
.categoryView{
    width:100%;
    overflow: hidden;
    position: relative;
}
    .rdwTopType{
        width: 810px;
        height: 60px;
        /*background: #EEF8FF;*/
        background: #ffffff;
        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
        box-sizing: border-box;
        padding-top:10px;
        .rdwTopTypeListCheck{
            background: #0F59A4!important;
            color:#ffffff!important;
        }
        .rdwTopTypeList{
            width: 240px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color:#3D3D3D;
            background: #F8F8F8;
            box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
            border-radius: 23px 23px 23px 23px;
            float:left;
            margin-left:18px;
            font-size: 18px;
            cursor:pointer;
        }
    }

    .showData{
        width:100%;
        overflow: hidden;
        .dataList{
            width:100%;
            overflow: hidden;
            margin-top:10px;
            .dataListTitle{
                width:100%;
                height: 40px;
                background: #EEF8FF;
                box-sizing: border-box;
                padding-left:20px;
                .dataListText{
                    width:calc(100% - 60px);
                    height: 40px;
                    line-height: 40px;
                    float:left;
                    font-size: 18px;
                    color: #0F59A4;
                    font-weight: 700;
                }
                .listIsShowChild{
                    width:40px;
                    height: 40px;
                    float:left;
                    margin-left:20px;
                    box-sizing: border-box;
                    padding-top:10px;
                    text-align: center;
                    img{
                        width:20px;
                        height:20px;
                    }
                }
            }
            .dataListChild{
                width:100%;
                overflow: hidden;
                //display: flex;
                //flex-wrap: wrap;
                box-sizing: border-box;
                .childListCheck{
                    background: #0F59A4!important;
                    color:#ffffff!important;
                }
                .childList:nth-child(5n) {
                    margin-right: 0!important;
                }
                .childList{
                    width:calc(20% - 15px);
                    height: 50px;
                    display: grid;
                    background: #F8F8F8;
                    margin-right:18px;
                    margin-top:10px;
                    box-sizing: border-box;
                    padding:0 10px;
                    float:left;
                    cursor:pointer;
                    .childListP{
                        align-self: center;
                        justify-self: center;
                        //text-align: center;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }
                }
            }
        }
    }
    .floatCheck{
        width:100%;
        min-height: 360px;
        background: #FFFFFF;
        box-shadow: 0px 0px 10px 0px rgba(15,89,164,0.5);
        border-radius: 0px 0px 0px 0px;
        border: 2px solid #0F59A4;
        position: absolute;
        top:24px;
        left:0;
        box-sizing: border-box;
        background: #ffffff;
        .categoryChildTop{
            width:100%;
            min-height: 130px;
            background: #0F59A4;
            box-sizing: border-box;
            padding:16px 20px 10px 20px;
            .categoryTopName{
                width:100%;
                min-height:40px;
                overflow: hidden;
                line-height: 20px;
                font-weight: 400;
                font-size: 18px;
                color: #FFFFFF;
            }
            .categoryTopHandle{
                width:100%;
                height: 48px;
                box-shadow: 1px 1px 2px 0px rgba(15,89,164,0.5);
                margin-top:8px;
                .topHandleLeft{
                    width: 160px;
                    height: 48px;
                    line-height: 48px;
                    background: #FFFFFF;
                    box-shadow: 1px 1px 2px 0px rgba(15,89,164,0.5);
                    float:left;
                    cursor:pointer;
                    font-weight: 700;
                    font-size: 22px;
                    color: #0F59A4;
                    box-sizing: border-box;
                    text-align: center;
                }
                .topHandleRight{
                    width:220px;
                    height: 48px;
                    line-height: 48px;
                    text-align: center;
                    float:right;
                    font-weight: 700;
                    font-size: 18px;
                    color: #0F59A4;
                    .tHRightTReturn{
                        width:120px;
                        height: 48px;
                        float:left;
                        background: #FFFFFF;
                        box-shadow: 1px 1px 2px 0px rgba(15,89,164,0.5);
                        cursor:pointer;
                    }
                    .tHRightTClose{
                        width:80px;
                        height: 48px;
                        float:left;
                        background: #FFFFFF;
                        box-shadow: 1px 1px 2px 0px rgba(15,89,164,0.5);
                        margin-left:20px;
                        cursor:pointer;
                    }
                }
            }
        }
        .categoryChildText{
            width:100%;
            height: 60px;
            background: #EEF8FF;
            box-sizing: border-box;
            padding:10px 20px;
            line-height: 20px;
        }
        .categoryChildBox{
            width:100%;
            box-sizing: border-box;
            padding:10px 0 20px 10px;

            .categoryChildListCheck{
                background: #0F59A4!important;
                color:#ffffff!important;
            }
            .categoryChildList{
                width:185px;
                height:60px;
                background: #F8F8F8;
                margin-top:10px;
                display: grid;
                align-self: center;
                justify-self: center;
                float:left;
                margin-left:10px;
                box-sizing: border-box;
                padding:0 10px;
                cursor:pointer;
                p{
                    align-self: center;
                    justify-self: center;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
        }
    }

    .buleSpan{
        color:#0F59A4;
    }
    .yellowSpan{
        color:#FFC800;
    }
</style>